import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.PURPLE,
    detailIdProp: 'lsId',
    detailUrl: '/LsDetail',
    listUrl: '/LsList',
    mapProp: 'lsMap',
    name: '外联系统',
    textProp: 'lsName',
    type: 'LS',
}
